// import React from 'react';
// import ReactDOM from 'react-dom';
import { fetchProducts, fetchProductsWithVariants } from './api/fetchProducts';
import { FieldInfo, fieldTypes, Product, Variant } from './interfaces';

export default class CTPicker {
  element: HTMLElement;
  config: Record<string, unknown> = {};
  currentSelection: string[] = [];
  isVariant = false;
  fieldType: fieldTypes = 'Symbol';
  fieldValue: string[] = [];
  template = `
      <table id="dataTable" class="display" style="width:100%" />`;

  constructor(
    container: HTMLElement,
    config: Record<string, unknown> = {},
    isVariant: boolean,
    fieldInfo: FieldInfo
  ) {
    this.element = container;
    this.config = config;
    this.isVariant = isVariant;
    this.fieldType = fieldInfo.fieldType;
    this.fieldValue = fieldInfo.fieldValue;
  }

  async show(): Promise<string[]> {
    this.element.innerHTML = this.template;
    // Todo - Ideally selection should happen in a react component - All the jquery and datatable refernces should be removed
    // ReactDOM.render(<Test test={props} />, this.element);
    const targetEl = $(this.element).find('#dataTable');
    const products = (await this.fetchCTData()).allProducts;
    const productsWithVariants = (await this.fetchCTData())
      .productsWithVariants;
    // eslint-disable-next-line
    const _self = this;
    const openRows: [] = [];

    function closeOpenedRows(table, selectedRow) {
      $.each(openRows, function (_, openRow) {
        // not the selected row!
        if ($.data(selectedRow) !== $.data(openRow)) {
          const rowToCollapse = table.row(openRow);
          rowToCollapse.child.hide();
          $(openRow).removeClass('shown');
          // replace icon to expand
          $(openRow)
            .find('td.details-control')
            .html('<span class="glyphicon glyphicon-plus"></span>');
          // remove from list
          const index = $.inArray(selectedRow, openRows);
          openRows.splice(index, 1);
        }
      });
    }

    $(document).ready(() => {
      const updateRowSelectionData = function (table, isVariant) {
        _self.currentSelection = $.map(
          table.rows('.selected').data(),
          function (row) {
            if (isVariant) {
              return row.sku;
            } else {
              return row.slug;
            }
          }
        );

        if (_self.currentSelection.length) {
          $('#selectionButton').show();
        } else {
          $('#selectionButton').hide();
        }
      };

      const selectConfig = () => {
        if (this.isVariant) {
          return false;
        }

        if (this.fieldType === 'Array') {
          return {
            style: 'multi',
          };
        }

        return true;
      };

      const table = targetEl.DataTable({
        select: selectConfig(),
        fixedHeader: true,
        order: [[1, 'asc']],
        data: this.isVariant ? productsWithVariants : products,
        columnDefs: [
          {
            targets: [4],
            visible: false,
            searchable: false,
          },
          { orderable: false, targets: [0, 3] },
          {
            targets: 3,
            render: function (data) {
              return '<img class="product-image" src="' + data + '">';
            },
          },
        ],
        paging: false,
        bInfo: false,
        columns: [
          {
            className: 'details-control',
            orderable: false,
            data: null,
            defaultContent: '',
            visible: this.isVariant ? true : false,
          },
          { title: 'Title', data: 'title' },
          { title: 'Slug', data: 'slug' },
          { title: 'Image', data: 'image' },
          { title: 'Sku', data: 'sku' },
        ],
      });

      table.rows(function (index: number, data: Product) {
        _self.fieldValue.forEach((value: string) => {
          if (data.slug === value) {
            table.row(index).select();
          }
        });

        return false;
      });
      table.on('select', function (e, dt, type) {
        if (type === 'row' && !_self.isVariant) {
          updateRowSelectionData(table, _self.isVariant);
        }
      });

      table.on('deselect', function (e, dt, type) {
        if (type === 'row' && !_self.isVariant) {
          updateRowSelectionData(table, _self.isVariant);
        }
      });

      function renderSubTable(currentRow: JQuery) {
        const tr = currentRow;
        const row = table.row(tr);
        $('#selectionButton').hide();

        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass('shown');
        } else {
          closeOpenedRows(table, tr);
          row
            .child('<table id="sub-data" class="bg-white nested-table" />')
            .show();

          const currentVariants = productsWithVariants.find(
            (product) => product.sku === row.data().sku
          ).variants;

          const subTable = $('#sub-data')
            .DataTable({
              paging: false,
              bInfo: false,
              select: {
                style: _self.fieldType === 'Array' ? 'multi' : 'single',
              },
              responsive: true,
              data: currentVariants,
              columns: [
                { data: 'attributes', title: 'Title' },
                { data: 'sku', title: 'sku' },
                { data: 'images', title: 'Image' },
              ],
              columnDefs: [
                {
                  targets: 0,
                  render: function (data) {
                    const variant = data.find(
                      (item) => item.name === 'variantTitle'
                    );

                    return (variant && variant.value['en-GB']) || 'not found';
                  },
                },
                {
                  targets: 2,
                  render: function (data) {
                    const url = data[0] && data[0].url;

                    if (url) {
                      return '<img class="product-image" src="' + url + '">';
                    }

                    return 'not found';
                  },
                },
              ],
            })
            .columns.adjust();

          subTable.on('select', function (e, dt, type) {
            if (type === 'row' && _self.isVariant) {
              updateRowSelectionData(subTable, _self.isVariant);
            }
          });

          subTable.on('deselect', function (e, dt, type) {
            if (type === 'row' && _self.isVariant) {
              updateRowSelectionData(subTable, _self.isVariant);
            }
          });

          subTable.rows(function (index: number, data: Product) {
            _self.fieldValue.forEach((value: string) => {
              if (data.sku === value) {
                subTable.row(index).select();
              }
            });

            return false;
          });

          $(tr).addClass('shown');

          openRows.push(tr);
        }
      }

      if (this.fieldValue.length && this.isVariant) {
        let preSelectedRow = null;

        const variantsParentProduct = productsWithVariants.find((product) => {
          return product.variants.find(
            (variant: Variant) => variant.sku === this.fieldValue[0]
          );
        });

        table.rows(function (index: number, data: Product) {
          if (data.sku === variantsParentProduct.sku) {
            preSelectedRow = table.row(index);
          }

          return false;
        });

        $(preSelectedRow.node()).closest('.odd').addClass('shown');
        renderSubTable($(preSelectedRow));
      }

      $('#dataTable tbody').on('click', 'td.details-control', function () {
        const curentRow = $(this).closest('tr');
        renderSubTable(curentRow);
      });

      $('#dataTable_filter').after(
        "<button id='selectionButton' style='display:none'>Select</button>"
      );
    });

    return new Promise((resolve) => {
      $(document)
        .find('#selectionButton')
        .on('click', function () {
          resolve(_self.currentSelection);
        });
    });
  }

  async fetchCTData(): Promise<Record<string, Product[]>> {
    return {
      productsWithVariants: await fetchProductsWithVariants(this.config),
      allProducts: await fetchProducts(this.config),
    };
  }
}
